export default {
  earn: {
    en: 'Earn',
  },
  myAzuro: {
    en: 'My Azuro',
  },
}
